import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import useQueryParams from '../utils/useQueryParams';
import useGlobalPpis from '../features/PpiContainer/hooks/useGlobalPpis';
import usePpsi from '../features/PpsiContainer/hooks/usePpsi';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import usePpis from '../features/PpiContainer/hooks/usePpis';
import {
  getGlobalPpiVariant,
  getGlobalVariantDialog,
  getPpisForPpsiId,
  isFetchingGlobalPpiVariant
} from '../features/PpiContainer/selectors';
import { MARKET_GLOBAL_LANG } from '../features/app/constants';
import PpiList from '../components/PpiList/PpiList';
import usePreviewPpi from '../features/PpiContainer/hooks/usePreviewPpi';
import { ppiCreateFromExistingRoute, ppiCreateRoute } from '../routes';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { EnrichmentData, States } from '../features/PpiContainer/constants';
import View from './views';
import { toJS } from 'utils/immutableUtils';
import PpiListSearch from 'components/PpiList/PpiListSeach';
import { getLanguage } from 'features/app/selectors';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import {
  fetchGlobalPpiVariant,
  openGlobalPpiDialog
} from 'features/PpiContainer/actions';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4)
  },
  paper: {
    margin: '0 auto',
    padding: theme.spacing(3),
    width: 720
  },
  actionsContainer: {
    marginTop: theme.spacing(2)
  },
  copyButton: {
    color: '#fff',
    marginRight: theme.spacing(2)
  },
  createButton: {
    padding: '6px 16px'
  },
  goBackButton: {
    padding: '6px 16px',
    float: 'right'
  }
}));

/**
 * View where user selects which PPI to copy data from when creating a PPI.
 *
 * Note: Only works when providing id of global PPSI (as query param fromPpsiId)
 */
const PpiCreateVariantGlobalView = ({ data }) => {
  const classes = useStyles();
  //   const [itemCode, fromPpsiId, localPpiCopy] = useQueryParams(
  //     'itemCode',
  //     'fromPpsiId',
  //     'localPpiCopy'
  //   );

  const [fromPpiId, setFromPpiId] = useState(null);
  const [fromPpiDataId, setFromPpiDataId] = useState(null);
  //const [itemCode, setItemCode]=useState(null)
  const dispatch = useDispatch();
  const history = useHistory();
  //   const [isFetchingGlobalPpis] = useGlobalPpis();
  //   const [isFetchingFromPpsi] = usePpsi(fromPpsiId);
  //   const [isFetching, ppis] = usePpis(States.PUBLISHED);
  //   const ppsis = toJS(ppis, []);
  //   const isFetchings = isFetchingGlobalPpis || isFetchingFromPpsi || isFetching;
  //   const globalPpi = useSelector(getPpisForPpsiId(fromPpsiId));
  //   const globalPpis = toJS(globalPpi, []);
  const ppiList = useSelector(getGlobalPpiVariant);
  const globalPpiVariant = toJS(ppiList, []);
  const [previewNode, openPreview] = usePreviewPpi();
  const prevIdRef = useRef(null);
  //   const [searchInput, setSearchInut] = useState('');
  //   const [localData, setLocalData] = useState([]);
  //   const languages = useSelector(getLanguage);
  const dialog = useSelector(getGlobalVariantDialog);
  const dialogState = toJS(dialog);
  const isFetching = useSelector(isFetchingGlobalPpiVariant);

  useEffect(() => {
    if (dialogState && dialogState.id && prevIdRef.current !== dialogState.id) {
      prevIdRef.current = dialogState.id;
      dispatch(fetchGlobalPpiVariant(dialogState.id));
    }
  }, [dialogState]);

  //   function filterData() {
  //     const data = ppsis.filter(i => {
  //       const name =
  //         i.publishedPPIEnrichmentData.info[languages].presentationName;
  //       const finalName = name.trim().toLowerCase();
  //       return finalName.includes(searchInput);
  //     });
  //     setLocalData(data);
  //   }

  // useEffect(() => {
  //   if (searchInput.length === 0) {
  //     setLocalData(ppsis);
  //   } else {
  //     const delayDebounceFn = setTimeout(() => {
  //       filterData();
  //     }, 500);

  //     return () => clearTimeout(delayDebounceFn);
  //   }
  // }, [isFetchings, searchInput]);

  //   if (isFetchings) {
  //     return <ProgressFullscreen />;
  //   }

  //   const sentData = localPpiCopy === 'true' ? localData : globalPpis;

  const handlePpiSelected = (event, { id }, data) => {
    setFromPpiId(id);
    setFromPpiDataId(event.target.value);
  };

  const handleClickCopyPpi = () => {
    if (!fromPpiId) {
      alert('Select instruction to copy');
      return;
    }

    history.push(
      ppiCreateFromExistingRoute(
        fromPpiId,
        data.ppiId,
        data.itemCode,
        data.enrichmentStatus
      )
    );
    dispatch(openGlobalPpiDialog(null));
  };
  // data.parentPpiId,
  //         data.ppiId,
  //         data.itemCode,
  //         data.enrichmentStatus
  //   const handleClickCreatePpi = () => {
  //     history.replace(ppiCreateRoute(itemCode));
  //   };

  View.PpiCreateFromExistingSelectPpi.visit();

  function navigateBack() {
    dispatch(openGlobalPpiDialog(null));
  }
  if (isFetching) {
    return <ProgressFullscreen open />;
  }
  return (
    <div className={classes.container}>
      {previewNode}

      <Dialog
        open={dialogState.open}
        PaperProps={{
          style: {
            width: '720px', // Set your desired width
            maxWidth: 'none' // Override the default maxWidth
          }
        }}
      >
        <Paper className={classes.paper}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h6">
              <FormattedMessage id="ppi.createGlobalVariantFromExistingSelectPpiHeader" />
            </Typography>
            {/* {localPpiCopy === 'true' && (
            <div>
              <PpiListSearch
                onChangeInput={setSearchInut}
                filterData={filterData}
              />
            </div>
          )} */}
          </div>
          {!isFetching && (
            <PpiList
              ppis={globalPpiVariant}
              selectedPpiDataId={fromPpiDataId}
              language={MARKET_GLOBAL_LANG}
              onChangeSelectedPpi={handlePpiSelected}
              openPreview={openPreview}
              //localPpiCopy="true"
              removeIsExclude={true}
              globalVariant={true}
            />
          )}
          {/* <h1>testing modal</h1> */}
          <div className={classes.actionsContainer}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleClickCopyPpi}
              classes={{ root: classes.copyButton }}
            >
              <FormattedMessage id="ppi.createVariantMenuItemLabel" />
            </Button>
            {/* <Tooltip title="Create instruction from scratch">
            <Button
              variant="text"
              onClick={handleClickCreatePpi}
              classes={{ root: classes.createButton }}
            >
              <FormattedMessage id="ppi.createInstruction" />
            </Button>
          </Tooltip> */}
            <Tooltip title="Go back to previous page">
              <Button
                variant="text"
                startIcon={<ArrowBackIcon />}
                position="left"
                classes={{ root: classes.goBackButton }}
                onClick={navigateBack}
              >
                <FormattedMessage id="ppi.goBack" />
              </Button>
            </Tooltip>
          </div>
        </Paper>
      </Dialog>
    </div>
  );
};

export default PpiCreateVariantGlobalView;
